var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600px", scrollable: "" },
      on: {
        input: function($event) {
          return _vm.cancel("lazadaIncludeShippingFee")
        }
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            return [
              _c("toggle-form", {
                attrs: {
                  state: _vm.state["lazadaIncludeShippingFee"],
                  text: _vm.$t("connector.lazada.field.shippingFee.label")
                },
                on: {
                  change: function($event) {
                    return _vm.confirm("lazadaIncludeShippingFee")
                  }
                },
                model: {
                  value: _vm.form.lazadaIncludeShippingFee,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "lazadaIncludeShippingFee", $$v)
                  },
                  expression: "form.lazadaIncludeShippingFee"
                }
              })
            ]
          }
        }
      ]),
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "app-card", attrs: { tile: "" } },
        [
          _c(
            "v-card-title",
            [
              _c(
                "div",
                { staticClass: "d-flex text-subtitle-1" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-4 icon-circle-yellow",
                      attrs: { color: "yellow darken-2" }
                    },
                    [_vm._v(" mdi-exclamation ")]
                  ),
                  _c("span", { staticClass: "yellow--text text--darken-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "connector.lazada.field.shippingFee.dialog.title"
                          )
                        ) +
                        " "
                    )
                  ])
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function($event) {
                      return _vm.cancel("lazadaIncludeShippingFee")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(" mdi-close ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("v-card-text", [
            _c("div", { staticClass: "mx-12" }, [
              _c(
                "div",
                { staticClass: "secondary--text subtitle-1 dialog-text" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "connector.lazada.field.shippingFee.dialog.description"
                        )
                      ) +
                      " "
                  )
                ]
              )
            ])
          ]),
          _c(
            "v-card-actions",
            { staticClass: "connector_dialog--action" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.cancel("lazadaIncludeShippingFee")
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("connector.lazada.btn.close")) + " "
                  )
                ]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", depressed: "", rounded: "" },
                  on: {
                    click: function($event) {
                      return _vm.submit("lazadaIncludeShippingFee")
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("connector.lazada.btn.connectShippingFee")
                      ) +
                      " "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }